<template>
  <page :breadcrumbBar="false" :manualInit="initStatus" @reload="initWidget">
    <div slot="title" class="dashTitle">
      <div class="pageTitle">
        <date-display></date-display>
      </div>
    </div>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on" title="Guide for Dashboard" id="guideBtn">
              Guide
              <v-icon right>mdi-television-guide</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="startTour()">
              <v-list-item-avatar>
                <v-icon>mdi-presentation-play</v-icon>
              </v-list-item-avatar>
              <v-list-item-title>Quick Tour</v-list-item-title>
            </v-list-item>
            <v-list-item @click="showWiki">
              <v-list-item-avatar>
                <v-icon>mdi-file-document</v-icon>
              </v-list-item-avatar>
              <v-list-item-title>Documentation</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu offset-y :close-on-content-click="false" v-model="widgetMenu" :min-width="300" :max-height="500">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on" id="widgetsBtn" title="Add/Remove Widget">
              Widgets
              <v-icon right>mdi-view-quilt</v-icon>
            </v-btn>
          </template>
          <widget-menu></widget-menu>
        </v-menu>
      </div>
    </div>
    <div class="dashboard">
      <grid-layout
        :layout="widgets"
        :col-num="12"
        :row-height="150"
        :is-draggable="true"
        :is-resizable="true"
        :is-mirrored="false"
        :vertical-compact="true"
        :margin="[10, 10]"
        :use-css-transforms="true"
        @layout-updated="layoutUpdatedEvent"
        :verticalCompact="true"
      >
        <grid-item
          v-for="item in widgets"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :minW="item.minW"
          :minH="item.minH"
          :i="item.i"
          :isResizable="item.isResizable"
          :key="item.i"
          dragIgnoreFrom="a, button, input"
        >
          <component :is="item.component"></component>
        </grid-item>
      </grid-layout>
    </div>
    <!-- TODO To finalize the contents and move to separate vue page AR: 6-Apr-2020 -->
    <div v-show="showWelcomePage && widgets.length === 0">
      <v-flex xs12>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg12 md12 xs12>
              <v-card class="mt-4 mx-auto">
                <v-card-title class="headline white lighten-5" primary-title>
                  Welcome to Odyssey 5!
                  <v-spacer></v-spacer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn text icon color="green" v-on="on" @click="showWelcomePage = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                    <span>Hide welcome page</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text class="pt-0">
                  <!-- <span><img alt="Odyssey5 Logo" src="/static/img/o5.png"/></span> -->
                  <div class="subheading font-weight-light grey--text">We have prepared some links to get you started:</div>
                  <v-divider class="my-4"></v-divider>
                  <v-container fluid grid-list-md>
                    <v-layout row wrap>
                      <v-flex xs12 md6 lg4>
                        <v-card class="mx-auto my-12">
                          <v-card-text>
                            <v-container fluid grid-list-sm>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-card-title class="toolbar-title-2-b">Get Started</v-card-title>
                                  <v-list>
                                    <v-list-item @click="startTour()">
                                      <v-list-item-avatar>
                                        <v-icon color="primary">mdi-presentation-play</v-icon>
                                      </v-list-item-avatar>
                                      <v-list-item-title>Quick Tour</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="widgetMenu = true">
                                      <v-list-item-avatar>
                                        <v-icon color="primary">mdi-view-quilt</v-icon>
                                      </v-list-item-avatar>
                                      <v-list-item-title>Add widgets</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="showWiki">
                                      <v-list-item-avatar>
                                        <v-icon color="primary">mdi-file-document</v-icon>
                                      </v-list-item-avatar>
                                      <v-list-item-title>Documentation</v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 md6 lg4>
                        <v-card class="mx-auto my-12">
                          <v-card-text>
                            <v-container fluid grid-list-sm>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-card-title class="toolbar-title-2-b">Next Steps</v-card-title>
                                  <v-list>
                                    <v-list-item @click="$router.push({ name: 'profile' })">
                                      <v-list-item-avatar>
                                        <v-icon color="cyan">mdi-account-settings-variant</v-icon>
                                      </v-list-item-avatar>
                                      <v-list-item-title>User Settings</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item>
                                      <v-list-item-avatar>
                                        <v-icon color="cyan">mdi-bell</v-icon>
                                      </v-list-item-avatar>
                                      <v-list-item-title>Communication Settings</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item>
                                      <v-list-item-avatar>
                                        <v-icon color="cyan">mdi-file-document</v-icon>
                                      </v-list-item-avatar>
                                      <v-list-item-title>Parameter Wizards</v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 md6 lg4>
                        <v-card class="mx-auto my-12">
                          <v-card-text>
                            <v-container fluid grid-list-sm>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-card-title class="toolbar-title-2-b">More Actions</v-card-title>
                                  <v-list>
                                    <v-list-item @click="doCreatePolicy" v-if="checkAccess([permissionKeys.perm_011045])">
                                      <v-list-item-avatar>
                                        <v-icon color="green">mdi-gavel</v-icon>
                                      </v-list-item-avatar>
                                      <v-list-item-title>New Policy</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="doCreateClaim" v-if="checkAccess([permissionKeys.perm_031035])">
                                      <v-list-item-avatar>
                                        <v-icon color="green">mdi-cash</v-icon>
                                      </v-list-item-avatar>
                                      <v-list-item-title>File Claim</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="$router.push({ name: 'receipts' })" v-if="checkAccess([permissionKeys.perm_041015])">
                                      <v-list-item-avatar>
                                        <v-icon color="green">mdi-receipt</v-icon>
                                      </v-list-item-avatar>
                                      <v-list-item-title>Issue Receipt</v-list-item-title>
                                    </v-list-item>
                                    <!-- <v-list-item avatar @click="$router.push({ name: 'payment'})">
                                        <v-list-item-avatar>
                                          <v-btn class="mx-2" fab dark small color="primary" v-on="on">
                                            <v-icon>mdi-cash-100</v-icon>
                                          </v-btn>
                                        </v-list-item-avatar>
                                        <v-list-item-title>New Payment</v-list-item-title>
                                      </v-list-item> -->
                                  </v-list>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </div>
    <tour ref="tour" :tour="tour"></tour>
  </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { GridLayout, GridItem } from 'vue-grid-layout'
import { widgets as widgetsParam } from './widgets'
import WidgetMenu from './widgets/WidgetMenu'
import DateDisplay from './DateDisplay'
import DashBoardTour from '@/const/tour/dashboard'
import { shortScopeMixin } from './widgets/shortScopeMixin'
import { POLICY_NEW_MODE } from '@/store/types'
import { permissionKeys } from '@/mixins/global/permissionKey'

export default {
  data() {
    return {
      widgetMenu: false,
      // Note that the object variable name is strict to i, x, y, w, h etc
      widgets: [],
      tour: DashBoardTour,
      showWelcomePage: true,
      permissionKeys: permissionKeys
    }
  },
  watch: {
    globalWidgets: function (value) {
      if (this.widgets.length > 0) {
        // we can just do convertWidgetState (not optimal as it will reload all the widgets)
        // Need find out what is added / removed
        // as we cannot watch for oldValue for vuex state, we will compare it to our local state
        if (value.length > this.widgets.length) {
          // Added
          let diff = value.filter((x) => !this.widgets.find((a) => x.i === a.i))
          if (diff && diff.length > 0) {
            if (widgetsParam[diff[0].i]) {
              this.widgets.push(this.convertWidget(diff[0], widgetsParam[diff[0].i]))
            }
          }
        } else if (value.length < this.widgets.length) {
          // Removed
          let diff = this.widgets.filter((x) => !value.find((a) => x.i === a.i))
          if (diff && diff.length > 0) {
            this.widgets.splice(this.widgets.indexOf(this.widgets.find((x) => x.i === diff[0].i)), 1)
          }
        }
      } else {
        // raw init
        this.convertWidgetState()
      }
    }
  },
  computed: {
    ...mapGetters(['checkAccess']),
    initStatus() {
      return this.$store.state.widgets.init
    },
    globalWidgets() {
      return this.$store.state.widgets.widgets
    }
  },
  methods: {
    ...mapActions(['initWidget']),
    convertWidgetState() {
      // Convert vuex widget state to dashboard local state
      this.widgets = []
      if (this.globalWidgets && this.globalWidgets.length > 0) {
        this.globalWidgets.map((widget) => {
          // Conversion needs to find widget library (to check availability and also fixed param like minW, minH etc)
          if (widgetsParam[widget.i]) {
            const convertedWidget = this.convertWidget(widget, widgetsParam[widget.i])
            if (convertedWidget) {
              this.widgets.push(convertedWidget)
            }
          }
        })
      }
    },
    convertWidget(globalWidget, paramWidget) {
      if (globalWidget && paramWidget) {
        const result = { ...globalWidget, ...paramWidget }
        return result
      } else {
        return undefined
      }
    },
    layoutUpdatedEvent(newLayout) {
      // Move event and resize event only return the widget that is being moved/resize
      // it does not return the affected widgets
      // so for this, we will detect changes in layout and send all info back
      this.$store.dispatch('adjustWidget', newLayout)
    },
    startTour() {
      if (this.$refs.tour) {
        this.$refs.tour.startTour()
      }
    },
    async doCreateClaim() {
      this.$router.push({ name: 'claimRegister' })
    },
    async doCreatePolicy() {
      this.$store.commit(POLICY_NEW_MODE)
      this.$router.push({ name: 'policyGeneral' })
    },
    showWiki() {
      // window.open('https://www.pst.sg/o5wiki/index.php/Main_Page', '_blank')
      // remove the comment below and window.open('https://www.pst.sg/o5wiki/index.php/Main_Page', '_blank') on top if client wanted to activate O5wiki
      window.open('https://www.pst.sg/o5wiki/client.html?userid=O5client&userpass=T2R5c3NleTU=', '_blank')
    }
  },
  mounted() {
    if (this.initStatus !== 1) {
      this.initWidget()
    } else {
      // For init status !== 1 (we will watch globalWidgets for changes)
      // Might be coming back from other place
      this.convertWidgetState()
    }
  },
  components: {
    GridLayout,
    GridItem,
    DateDisplay,
    WidgetMenu
  },
  mixins: [shortScopeMixin(true)]
}
</script>

<style lang="scss">
@import '../../assets/scss/base.scss';

// As flexible grid has a defined set of rules
// Its hard to make it fit to responsive design
// Thus, for now we will set a min width to dashboard content
.dashboard {
  width: 100%;
  height: 100%;
  min-width: 1000px;
  overflow: hidden;
}
// Overwrite grid css
.vue-grid-item.vue-grid-placeholder {
  background: $primary !important;
  opacity: 0.2;
  transition-duration: 100ms;
  z-index: 2;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}
</style>
